

exports.__esModule = true;
exports.$contingencyHandler = $contingencyHandler;
var _uiRouter = require("uiRouter");
var _logger = require("xo-beaver/dist/logger");
var _squid = require("squid");
function showGenericError(code) {
  return function (errCode) {
    errCode = code || errCode;
    // Encode error text
    errCode = errCode ? window.btoa(errCode) : errCode;
    _uiRouter.$state.go('checkout.genericError', {
      code: errCode
    });
  };
}

/**
 * Route with default parameters unless special handler implemented otherwise
 *
 * To satisfy url: '/pageAddCard/:country/:fiType' in the route definition.
 * {country: ..., fiType: ...} must be passed for ui.router..
 *
 */
function route(path, params) {
  return function () {
    _uiRouter.$state.go(path, params);
  };
}
var routeToAddCC = function routeToAddCC(msg, contingency) {
  var gamblingCauses = ['PAYER_FUNDING_INSTRUMENT_INELIGIBLE', 'PAYER_FINANCIAL_INSTRUMENT_OUT_OF_COUNTRY', 'PAYER_FINANCIAL_INSTRUMENT_UNDER_AGE'];
  var isGambling = gamblingCauses.indexOf(contingency.cause) > -1;
  var param = isGambling ? {
    gaming: '1'
  } : {};
  return route('checkout.pageAddCard.addCardFlow.addCard', param);
};
function forbidden(err) {
  throw new _squid.$Forbidden(err);
}
function fallback(product) {
  return function (err) {
    throw new _squid.$FallbackError({
      reason: err,
      product: product
    });
  };
}
function $contingencyHandler(contingency) {
  if (contingency instanceof _squid.$Contingency) {
    // Leave a footprint here. The subsequent state where log how it goes..
    _logger.$logger.warn('contingency_handler', contingency);
    return contingency.handle({
      // TODO : modify these routes
      // Route
      NEED_CREDIT_CARD: routeToAddCC,
      NEED_CONFIRMED_CARD: routeToAddCC,
      NEED_CREDIT_CARD_OR_BANK_ACCOUNT: routeToAddCC,
      EXPIRED_CREDIT_CARD: routeToAddCC,
      // Generic Error Pages
      CURRENCY_COMPLIANCE: showGenericError(),
      INVALID_RESOURCE_ID: showGenericError(),
      PAYMENT_ALREADY_DONE: showGenericError(),
      PAYEE_BLOCKED_TRANSACTION: showGenericError(),
      RESTRICTED_USER: showGenericError(),
      PAYMENT_DENIED: showGenericError(),
      PAYER_CANNOT_PAY: showGenericError(),
      PAYEE_ACCOUNT_RESTRICTED: showGenericError(),
      PAYER_COUNTRY_NOT_ALLOWED: showGenericError(),
      PAYER_COUNTRY_NOT_ALLOWED_DCF: showGenericError('XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF'),
      PAYER_COUNTRY_NOT_ENABLED: showGenericError(),
      PAYER_LOGIN_COUNTRY_NOT_ALLOWED: showGenericError(),
      GAMING_FUNDING_SOURCE_VALIDATION_FAILED: showGenericError(),
      GUEST_CHECKOUT_NOT_ALLOWED: showGenericError(),
      EINVALIDCSRF_JWT_EXPIRED: showGenericError(),
      // Fallbacks
      TRANSACTION_REFUSED: fallback('ux'),
      VERIFY_USER_IDENTITY: fallback('ux'),
      SENDING_LIMIT_EXCEEDED: fallback('ux'),
      PAYER_INVALID_FOR_PAYMENT: fallback('ux'),
      PAYMENT_CANNOT_BE_INITIATED: fallback('ux'),
      PERMISSION_DENIED: fallback('ux'),
      NEGATIVE_BALANCE_TRANSACTION_REFUSED: fallback('ux'),
      INVALID_TOKEN: fallback('ux'),
      INVALID_FUNDING_OPTION: fallback('ux'),
      INTERNAL_SERVICE_ERROR: fallback('ux'),
      VALIDATION_ERROR: fallback('ux'),
      SHIPPING_ADDRESS_INVALID: fallback('ux'),
      RISK_DENIED: fallback('ux'),
      DOMESTIC_TRANSACTION_REQUIRED: fallback('ux'),
      INVALID_ARGUMENT: fallback('ux'),
      CREDIT_PAYMENT_NOT_ALLOWED: fallback('ux'),
      UNSUPPORTED_PAYEE_CURRENCY: fallback('ux'),
      PAYEE_ACCOUNT_LOCKED_OR_CLOSED: fallback('ux'),
      CANNOT_PAY_SELF: fallback('hermes'),
      // Residential Address Fallbacks
      RESIDENTIAL_ADDRESS_VALIDATION_ERROR: fallback('ux'),
      // Forbidden
      BUYER_NOT_SET: forbidden,
      // TODO: duplicate - PAYER_INVALID_FOR_PAYMENT: forbidden,
      // Default
      DEFAULT: function logUnhandledContingency() {
        _logger.$logger.warn("ui_unhandled_contingency_" + this.message);
        throw new _squid.$FallbackError({
          reason: 'unhandled_contingency',
          product: 'ux'
        });
      }
    });
  }
}
angular.value("$contingencyHandler", $contingencyHandler);
_uiRouter.$state;
_logger.$logger;
_squid.$Forbidden;
_squid.$FallbackError;
_squid.$Contingency;


//////////////////
// WEBPACK FOOTER
// ./js/lib/contingency.js
// module id = ./js/lib/contingency.js
// module chunks = 0